import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../components/AuthContext';
import api from '../api';
import AdminLayout from '../components/AdminLayout';
import './AdminMerchantAccountsPage.css';

// Configurazione CSS
const CSS_DOMAIN_ID = '5622098383'; // CSS_DOMAIN_ID corretto

const AdminMerchantAccountsPage = () => {
  const { user } = useContext(AuthContext);
  const [sellers, setSellers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [processing, setProcessing] = useState({});
  
  // Modal states
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showPermissionsModal, setShowPermissionsModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedSeller, setSelectedSeller] = useState(null);
  const [sellerDetails, setSellerDetails] = useState(null);
  const [merchantDetails, setMerchantDetails] = useState(null);
  const [editMerchantForm, setEditMerchantForm] = useState({
    name: '',
    websiteUrl: '',
    businessInformation: {
      address: {
        streetAddress: '',
        locality: '',
        region: '',
        postalCode: '',
        country: 'IT'
      },
      phoneNumber: '',
      customerService: {
        url: '',
        email: '',
        phoneNumber: ''
      }
    },
    adsLinks: [
      {
        adsId: '5202420264',
        status: 'active'
      }
    ]
  });
  const [createStep, setCreateStep] = useState(1);
  const [merchantForm, setMerchantForm] = useState({
    merchant_name: '',
    website_url: '',
    admin_email: '',
    business_name: '',
    phone_number: '',
    address_street: '',
    address_city: '',
    address_province: '',
    address_zip: '',
    address_country: 'IT',
    customer_service_url: '',
    customer_service_email: '',
    customer_service_phone: '',
    country: 'IT',
    currency: 'EUR',
    language: 'it'
  });
  const [showActionsModal, setShowActionsModal] = useState(false);

  useEffect(() => {
    if (user && user.role === 'admin') {
      loadSellers();
    }
  }, [user]);

  const loadSellers = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await api.get('/google-shopping/merchant/list');
      setSellers(response.data.sellers || []);
    } catch (err) {
      setError('Errore nel caricamento dei seller');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateMerchant = async (sellerId) => {
    try {
      setProcessing(prev => ({ ...prev, [sellerId]: true }));
      
      // Step 1: Recupera dettagli seller
      const response = await api.get(`/google-shopping/merchant/seller/${sellerId}`);
      const seller = response.data.seller;
      
      setSelectedSeller(seller);
      setSellerDetails(seller);
      
      // Pre-popola il form con i dati del seller
      setMerchantForm({
        merchant_name: seller.store_name ? `${seller.store_name}` : '',
        website_url: seller.website || '',
        admin_email: seller.email || '',
        business_name: seller.business_name || '',
        phone_number: seller.phone_number || '',
        address_street: seller.address || '',
        address_city: seller.city || '',
        address_province: seller.province || '',
        address_zip: seller.zip || '',
        address_country: seller.country || 'IT',
        customer_service_url: seller.customer_service_url || seller.website || '',
        customer_service_email: seller.customer_service_email || seller.email || '',
        customer_service_phone: seller.phone_number || '',
        country: seller.country || 'IT',
        currency: seller.currency || 'EUR',
        language: seller.language || 'it'
      });
      
      setCreateStep(1);
      setShowCreateModal(true);
    } catch (err) {
      setError('Errore nel recupero dei dati del seller');
      console.error(err);
    } finally {
      setProcessing(prev => ({ ...prev, [sellerId]: false }));
    }
  };

  const handleCreateMerchantStep2 = async () => {
    try {
      setProcessing(prev => ({ ...prev, create: true }));
      
      const payload = {
        seller_id: selectedSeller.user_id,
        merchant_name: merchantForm.merchant_name,
        website_url: merchantForm.website_url,
        admin_email: merchantForm.admin_email,
        business_name: merchantForm.business_name,
        phone_number: merchantForm.phone_number,
        businessInformation: {
          address: {
            streetAddress: merchantForm.address_street,
            locality: merchantForm.address_city,
            region: merchantForm.address_province,
            postalCode: merchantForm.address_zip,
            country: 'IT'
          },
          phoneNumber: merchantForm.phone_number,
          customerService: {
            url: merchantForm.customer_service_url,
            email: merchantForm.customer_service_email,
            phoneNumber: merchantForm.customer_service_phone
          }
        },
        adsLinks: [
          {
            adsId: '5202420264',
            status: 'active'
          }
        ],
        country: 'IT',
        currency: merchantForm.currency,
        language: merchantForm.language
      };

      console.log('Payload creazione merchant:', payload);

      const response = await api.post('/google-shopping/merchant/create', payload);

      if (response.data.success) {
        setShowCreateModal(false);
        setSelectedSeller(null);
        setSellerDetails(null);
        setMerchantForm({
          merchant_name: '',
          website_url: '',
          admin_email: '',
          business_name: '',
          phone_number: '',
          address_street: '',
          address_city: '',
          address_province: '',
          address_zip: '',
          address_country: 'IT',
          customer_service_url: '',
          customer_service_email: '',
          customer_service_phone: '',
          country: 'IT',
          currency: 'EUR',
          language: 'it'
        });
        setCreateStep(1);
        
        // Ricarica la lista dei seller
        await loadSellers();
        
        // Mostra messaggio di successo
        alert('Merchant account creato con successo!');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Errore nella creazione del merchant account');
      console.error(err);
    } finally {
      setProcessing(prev => ({ ...prev, create: false }));
    }
  };

  const handleGrantPermissions = async (merchantId, sellerEmail) => {
    try {
      setProcessing(prev => ({ ...prev, [`perms_${merchantId}`]: true }));
      
      await api.post('/google-shopping/merchant/grant-permissions', {
        merchant_id: merchantId,
        seller_email: sellerEmail
      });

      await loadSellers();
      alert('Autorizzazioni seller concesse con successo!');
    } catch (err) {
      setError(err.response?.data?.message || 'Errore nella concessione delle autorizzazioni');
      console.error(err);
    } finally {
      setProcessing(prev => ({ ...prev, [`perms_${merchantId}`]: false }));
    }
  };

  const handleUploadProducts = async (merchantId, sellerId) => {
    try {
      setProcessing(prev => ({ ...prev, [`upload_${merchantId}`]: true }));
      
      let response;
      
      // Gestione speciale per Loverlist CSS
      // merchantId === CSS_DOMAIN_ID quando viene chiamato da UI per Loverlist
      if (merchantId === CSS_DOMAIN_ID) {
        response = await api.post('/google-shopping/loverlist/upload-products-css');
      } else {
        response = await api.post('/google-shopping/merchant/upload-products', {
          merchantId: merchantId,
          sellerId: sellerId
        });
      }
      
      if (response.data.success) {
        if (merchantId === CSS_DOMAIN_ID) {
          const data = response.data.data;
          if (data.limitReached) {
            alert(` Caricamento CSS TEST completato: ${data.uploaded} prodotti CSS caricati (limite 1000 raggiunto)`);
          } else {
            alert(`Caricamento CSS completato: ${data.uploaded} prodotti CSS caricati`);
          }
        } else {
          alert(`Caricamento completato: ${response.data.data.uploaded} prodotti caricati`);
        }
      } else {
        setError(response.data.message || 'Errore nel caricamento dei prodotti');
      }
      
    } catch (err) {
      setError('Errore nel caricamento dei prodotti');
      console.error(err);
    } finally {
      setProcessing(prev => ({ ...prev, [`upload_${merchantId}`]: false }));
    }
  };

  const handleDeleteMerchant = async (merchantId) => {
    if (!window.confirm('Sei sicuro di voler eliminare questo merchant account? L\'operazione è irreversibile.')) return;
    try {
      setProcessing(prev => ({ ...prev, [`delete_${merchantId}`]: true }));
      const response = await api.post('/google-shopping/merchant/delete', { merchantId });
      if (response.data.success) {
        alert('Merchant account eliminato con successo!');
        await loadSellers();
      } else {
        setError(response.data.message || 'Errore durante l\'eliminazione del merchant account');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Errore durante l\'eliminazione del merchant account');
      console.error(err);
    } finally {
      setProcessing(prev => ({ ...prev, [`delete_${merchantId}`]: false }));
    }
  };

  const handleEditMerchant = async (merchantId) => {
    try {
      setProcessing(prev => ({ ...prev, [`edit_${merchantId}`]: true }));
      
      // Recupera i dettagli freschi del merchant da Google API
      const response = await api.get(`/google-shopping/merchant/${merchantId}`);
      
      if (response.data.success) {
        const merchantData = response.data.data;
        setMerchantDetails(merchantData);
        
        // Pre-popola il form con i dati attuali
        setEditMerchantForm({
          name: merchantData.name || '',
          websiteUrl: merchantData.websiteUrl || '',
          businessInformation: {
            address: {
              streetAddress: merchantData.businessInformation?.address?.streetAddress || '',
              locality: merchantData.businessInformation?.address?.locality || '',
              region: merchantData.businessInformation?.address?.region || '',
              postalCode: merchantData.businessInformation?.address?.postalCode || '',
              country: 'IT'
            },
            phoneNumber: merchantData.businessInformation?.phoneNumber || '',
            customerService: {
              url: merchantData.businessInformation?.customerService?.url || '',
              email: merchantData.businessInformation?.customerService?.email || '',
              phoneNumber: merchantData.businessInformation?.customerService?.phoneNumber || ''
            }
          },
          adsLinks: merchantData.adsLinks || [
            {
              adsId: '5202420264',
              status: 'active'
            }
          ]
        });
        
        setShowEditModal(true);
      } else {
        setError('Errore nel recupero dei dettagli del merchant');
      }
    } catch (err) {
      setError('Errore nel recupero dei dettagli del merchant');
      console.error(err);
    } finally {
      setProcessing(prev => ({ ...prev, [`edit_${merchantId}`]: false }));
    }
  };

  const handleUpdateMerchant = async () => {
    if (!merchantDetails) return;
    
    try {
      setProcessing(prev => ({ ...prev, update: true }));
      
      const response = await api.put(`/google-shopping/merchant/${merchantDetails.id}`, editMerchantForm);
      
      if (response.data.success) {
        alert('Merchant account aggiornato con successo!');
        setShowEditModal(false);
        setMerchantDetails(null);
        setEditMerchantForm({
          name: '',
          websiteUrl: '',
          businessInformation: {
            address: {
              streetAddress: '',
              locality: '',
              region: '',
              postalCode: '',
              country: 'IT'
            },
            phoneNumber: '',
            customerService: {
              url: '',
              email: '',
              phoneNumber: ''
            }
          },
          adsLinks: [
            {
              adsId: '5202420264',
              status: 'active'
            }
          ]
        });
        
        await loadSellers();
      } else {
        setError(response.data.message || 'Errore durante l\'aggiornamento del merchant account');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Errore durante l\'aggiornamento del merchant account');
      console.error(err);
    } finally {
      setProcessing(prev => ({ ...prev, update: false }));
    }
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'active':
        return <span className="status-badge status-active">Attivo</span>;
      case 'pending':
        return <span className="status-badge status-pending">In Attesa</span>;
      case 'suspended':
        return <span className="status-badge status-suspended">Sospeso</span>;
      case 'not_created':
        return <span className="status-badge status-not-created">Non Creato</span>;
      default:
        return <span className="status-badge status-unknown">Sconosciuto</span>;
    }
  };

  const getPermissionsBadge = (granted) => {
    return granted ? 
      <span className="permissions-badge permissions-granted">Concesse</span> :
      <span className="permissions-badge permissions-not-granted">Non Concesse</span>;
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    
    const now = new Date();
    const date = new Date(dateString);
    const diffInMs = now - date;
    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
    
    if (diffInMinutes < 1) {
      return 'adesso';
    } else if (diffInMinutes < 60) {
      return `${diffInMinutes}m fa`;
    } else if (diffInHours < 24) {
      const remainingMinutes = diffInMinutes % 60;
      if (remainingMinutes === 0) {
        return `${diffInHours}h fa`;
      } else {
        return `${diffInHours}h ${remainingMinutes}m fa`;
      }
    } else {
      const diffInDays = Math.floor(diffInHours / 24);
      if (diffInDays === 1) {
        return '1 giorno fa';
      } else {
        return `${diffInDays} giorni fa`;
      }
    }
  };

  if (loading) {
    return (
      <AdminLayout>
        <div className="admin-merchant-accounts-page">
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>Caricamento seller...</p>
          </div>
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="admin-merchant-accounts-page">
        <div className="page-header">
          <h1>Gestione Merchant Accounts</h1>
          <p>Gestisci i merchant account Google Shopping per tutti i seller </p>
        </div>

        {error && (
          <div className="alert alert-danger">
            {error}
            <button onClick={() => setError(null)} className="close-btn">&times;</button>
          </div>
        )}

        <div className="stats-section">
          <div className="stat-card">
            <div className="stat-number">{sellers.length}</div>
            <div className="stat-label">Seller Totali</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">{sellers.filter(s => s.sync_status === 'completed').length}</div>
            <div className="stat-label">Sync Completate</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">{sellers.filter(s => s.sync_status === 'in_progress').length}</div>
            <div className="stat-label">Sync in Corso</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">{sellers.filter(s => s.merchant_status === 'not_created').length}</div>
            <div className="stat-label">Da Creare</div>
          </div>
        </div>

        <div className="sellers-section">
          <h2>Lista Seller</h2>
          
          {sellers.length === 0 ? (
            <div className="no-sellers">
              <p>Nessun seller trovato.</p>
            </div>
          ) : (
            <div className="sellers-table">
              <table>
                <thead>
                  <tr>
                    <th>Logo</th>
                    <th>Seller</th>
                    <th>Stato Merchant</th>
                    <th>Merchant ID</th>
                    <th>Ultimo Aggiornamento</th>
                    <th>Esito Sync</th>
                    <th>Varianti ES</th>
                    <th>Tariffe Spedizione</th>
                    <th>Azioni</th>
                  </tr>
                </thead>
                <tbody>
                  {sellers.map(seller => (
                    <tr key={seller.user_id}>
                      <td>
                        {seller.logo_square ? (
                          <img src={seller.logo_square} alt="Logo" className="logo-square" />
                        ) : (
                          <div className="logo-square-placeholder">
                            {seller.store_name ? seller.store_name.slice(0,2).toUpperCase() : '??'}
                          </div>
                        )}
                      </td>
                      <td>
                        <div className="seller-info">
                          <div className="seller-name">
                            {seller.store_name || `${seller.name} ${seller.last_name}`}
                          </div>
                          {seller.seller_handle && (
                            <div className="seller-handle">
                              {seller.is_loverlist ? (
                                <span style={{ color: '#007bff' }}>@{seller.seller_handle}</span>
                              ) : (
                                `@${seller.seller_handle}`
                              )}
                            </div>
                          )}
                        </div>
                      </td>
                      <td>{getStatusBadge(seller.merchant_status)}</td>
                      <td>
                        {seller.merchant_id ? (
                          <div className="merchant-id">
                            <span>{seller.merchant_id}</span>
                            {seller.merchant_id && (
                              <a 
                                href={`https://merchants.google.com/mc/merchantprofile/overview?merchantId=${seller.merchant_id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="merchant-link"
                              >
                                Apri →
                              </a>
                            )}
                          </div>
                        ) : (
                          '-'
                        )}
                      </td>
                      <td>{formatDate(seller.last_sync)}</td>
                      <td>
                        {seller.sync_status ? (
                          <span style={{ 
                            padding: '4px 8px',
                            borderRadius: '4px',
                            backgroundColor: 
                              seller.sync_status === 'completed' ? '#28a745' :
                              seller.sync_status === 'in_progress' ? '#ffc107' :
                              seller.sync_status === 'error' ? '#dc3545' : '#6c757d',
                            color: 'white',
                            fontWeight: 'bold'
                          }}>
                            {seller.sync_status === 'completed' ? 'Completato' :
                             seller.sync_status === 'in_progress' ? 'In Corso' :
                             seller.sync_status === 'error' ? 'Errore' : 'Idle'}
                          </span>
                        ) : (
                          <span style={{ 
                            padding: '4px 8px',
                            borderRadius: '4px',
                            backgroundColor: '#6c757d',
                            color: 'white',
                            fontWeight: 'bold'
                          }}>
                            Mai sincronizzato
                          </span>
                        )}
                      </td>
                      <td>
                        <span style={{ 
                          padding: '4px 8px',
                          borderRadius: '4px',
                          backgroundColor: seller.variants_count > 0 ? '#17a2b8' : '#6c757d',
                          color: 'white',
                          fontWeight: 'bold'
                        }}>
                          {seller.variants_count?.toLocaleString() || 0}
                        </span>
                      </td>
                      <td>
                          {seller.is_loverlist ? (
                            <button
                              className="btn btn-success btn-sm"
                              onClick={() => {
                                setSelectedSeller(seller);
                                setShowActionsModal(true);
                              }}
                            >
                              Gestisci Loverlist
                            </button>
                          ) : seller.merchant_status === 'not_created' ? (
                            <button
                            className="btn btn-warning btn-sm"
                              onClick={() => handleCreateMerchant(seller.user_id)}
                              disabled={processing[seller.user_id]}
                            >
                            {processing[seller.user_id] ? 'Creazione...' : 'Crea Merchant'}
                            </button>
                          ) : (
                              <button
                                className="btn btn-success btn-sm"
                                onClick={() => {
                                  setSelectedSeller(seller);
                              setShowActionsModal(true);
                                }}
                              >
                                Gestisci
                              </button>
                          )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* Modal Creazione Merchant Account */}
        {showCreateModal && selectedSeller && (
          <div className="modal-overlay">
            <div className="modal">
              <div className="modal-header">
                <h3>Creazione Merchant Account</h3>
                <button 
                  className="modal-close"
                  onClick={() => setShowCreateModal(false)}
                >
                  &times;
                </button>
              </div>
              
              <div className="modal-body">
                {createStep === 1 ? (
                  <div className="create-step-1">
                    <h4>Step 1: Verifica Dati Seller</h4>
                    <p>Verifica e modifica i dati per la creazione del merchant account:</p>
                    
                    <div className="form-group">
                      <label>Nome Merchant:</label>
                      <input
                        type="text"
                        value={merchantForm.merchant_name}
                        onChange={(e) => setMerchantForm(prev => ({ ...prev, merchant_name: e.target.value }))}
                        placeholder="Nome del merchant account"
                      />
                    </div>
                    
                    <div className="form-group">
                      <label>Website URL:</label>
                      <input
                        type="url"
                        value={merchantForm.website_url}
                        onChange={(e) => setMerchantForm(prev => ({ ...prev, website_url: e.target.value }))}
                        placeholder="https://example.com"
                      />
                    </div>
                    
                    <div className="form-group">
                      <label>Email Amministratore:</label>
                      <input
                        type="email"
                        value={merchantForm.admin_email}
                        onChange={(e) => setMerchantForm(prev => ({ ...prev, admin_email: e.target.value }))}
                        placeholder="admin@example.com"
                      />
                    </div>
                    
                    <div className="form-group">
                      <label>Nome Azienda (opzionale):</label>
                      <input
                        type="text"
                        value={merchantForm.business_name}
                        onChange={(e) => setMerchantForm(prev => ({ ...prev, business_name: e.target.value }))}
                        placeholder="Nome azienda"
                      />
                    </div>
                    
                    <div className="form-group">
                      <label>Telefono (opzionale):</label>
                      <input
                        type="tel"
                        value={merchantForm.phone_number}
                        onChange={(e) => setMerchantForm(prev => ({ ...prev, phone_number: e.target.value }))}
                        placeholder="+39 123 456 7890"
                      />
                    </div>
                    
                    <div className="form-group">
                      <label>Indirizzo (via):</label>
                      <input type="text" value={merchantForm.address_street} onChange={e => setMerchantForm(prev => ({ ...prev, address_street: e.target.value }))} placeholder="Via Roma 123" />
                    </div>
                    <div className="form-group">
                      <label>Città:</label>
                      <input type="text" value={merchantForm.address_city} onChange={e => setMerchantForm(prev => ({ ...prev, address_city: e.target.value }))} placeholder="Città" />
                    </div>
                    <div className="form-group">
                      <label>Provincia:</label>
                      <input type="text" value={merchantForm.address_province} onChange={e => setMerchantForm(prev => ({ ...prev, address_province: e.target.value }))} placeholder="Provincia" />
                    </div>
                    <div className="form-group">
                      <label>CAP:</label>
                      <input type="text" value={merchantForm.address_zip} onChange={e => setMerchantForm(prev => ({ ...prev, address_zip: e.target.value }))} placeholder="CAP" />
                    </div>
                    <div className="form-group">
                      <label>Paese:</label>
                      <select value={merchantForm.address_country} onChange={e => setMerchantForm(prev => ({ ...prev, address_country: e.target.value }))}>
                        <option value="IT">Italia</option>
                        <option value="US">Stati Uniti</option>
                        <option value="GB">Regno Unito</option>
                        <option value="DE">Germania</option>
                        <option value="FR">Francia</option>
                        <option value="ES">Spagna</option>
                      </select>
                    </div>
                    
                    <div className="form-group">
                      <label>Customer Service URL:</label>
                      <input type="text" value={merchantForm.customer_service_url} onChange={e => setMerchantForm(prev => ({ ...prev, customer_service_url: e.target.value }))} placeholder="https://..." />
                    </div>
                    <div className="form-group">
                      <label>Customer Service Email:</label>
                      <input type="email" value={merchantForm.customer_service_email} onChange={e => setMerchantForm(prev => ({ ...prev, customer_service_email: e.target.value }))} placeholder="email@esempio.com" />
                    </div>
                    <div className="form-group">
                      <label>Customer Service Telefono:</label>
                      <input type="text" value={merchantForm.customer_service_phone} onChange={e => setMerchantForm(prev => ({ ...prev, customer_service_phone: e.target.value }))} placeholder="+39 ..." />
                    </div>
                    
                    <div className="seller-preview">
                      <h5>Dati Seller:</h5>
                      <p><strong>Nome:</strong> {selectedSeller.store_name || `${selectedSeller.name} ${selectedSeller.last_name}`}</p>
                      <p><strong>Email:</strong> {selectedSeller.email}</p>
                      <p><strong>Website:</strong> {selectedSeller.website || 'Non specificato'}</p>
                    </div>
                  </div>
                ) : (
                  <div className="create-step-2">
                    <h4>Step 2: Conferma Creazione</h4>
                    <p>Conferma i dati per la creazione del merchant account:</p>
                    
                    <div className="confirmation-details">
                      <p><strong>Nome Merchant:</strong> {merchantForm.merchant_name}</p>
                      <p><strong>Website:</strong> {merchantForm.website_url}</p>
                      <p><strong>Email Admin:</strong> {merchantForm.admin_email}</p>
                      {merchantForm.business_name && <p><strong>Nome Azienda:</strong> {merchantForm.business_name}</p>}
                      {merchantForm.phone_number && <p><strong>Telefono:</strong> {merchantForm.phone_number}</p>}
                      {merchantForm.address_street && <p><strong>Indirizzo:</strong> {merchantForm.address_street}, {merchantForm.address_city} ({merchantForm.address_zip})</p>}
                      <p><strong>Paese:</strong> {merchantForm.country}</p>
                      <p><strong>Parent Account:</strong> AMC Principale (5622751379)</p>
                    </div>
                    
                    <div className="warning">
                      <p>⚠️ Questa operazione creerà un nuovo merchant account su Google. Assicurati che i dati siano corretti.</p>
                    </div>
                  </div>
                )}
              </div>
              
              <div className="modal-footer">
                {createStep === 1 ? (
                  <>
                    <button 
                      className="btn btn-secondary"
                      onClick={() => setShowCreateModal(false)}
                    >
                      Annulla
                    </button>
                    <button 
                      className="btn btn-primary"
                      onClick={() => setCreateStep(2)}
                      disabled={!merchantForm.merchant_name || !merchantForm.website_url || !merchantForm.admin_email}
                    >
                      Avanti
                    </button>
                  </>
                ) : (
                  <>
                    <button 
                      className="btn btn-secondary"
                      onClick={() => setCreateStep(1)}
                    >
                      Indietro
                    </button>
                    <button 
                      className="btn btn-primary"
                      onClick={handleCreateMerchantStep2}
                      disabled={processing.create}
                    >
                      {processing.create ? 'Creazione in corso...' : 'Crea Merchant Account'}
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Modal Gestione Autorizzazioni */}
        {showPermissionsModal && selectedSeller && (
          <div className="modal-overlay">
            <div className="modal">
              <div className="modal-header">
                <h3>Gestione Autorizzazioni</h3>
                <button 
                  className="modal-close"
                  onClick={() => setShowPermissionsModal(false)}
                >
                  &times;
                </button>
              </div>
              
              <div className="modal-body">
                <h4>Merchant Account: {selectedSeller.merchant_name}</h4>
                <p>ID: {selectedSeller.merchant_id}</p>
                
                <div className="permissions-section">
                  <h5>Autorizzazioni Seller</h5>
                  <p>Stato attuale: {getPermissionsBadge(selectedSeller.seller_permissions_granted)}</p>
                  {!selectedSeller.seller_permissions_granted && (
                    <button
                      className="btn btn-success"
                      onClick={() => {
                        handleGrantPermissions(selectedSeller.merchant_id, selectedSeller.email);
                        setShowPermissionsModal(false);
                      }}
                      disabled={processing[`perms_${selectedSeller.merchant_id}`]}
                    >
                      {processing[`perms_${selectedSeller.merchant_id}`] ? 'Concessione...' : 'Concedi Autorizzazioni'}
                    </button>
                  )}
                </div>

                <div className="products-section">
                  <h5>Gestione Prodotti</h5>
                  <p>Forza la sincronizzazione dei prodotti del seller sul merchant account Google Shopping</p>
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      handleUploadProducts(selectedSeller.merchant_id, selectedSeller.user_id);
                      setShowPermissionsModal(false);
                    }}
                    disabled={processing[`upload_${selectedSeller.merchant_id}`]}
                  >
                    {processing[`upload_${selectedSeller.merchant_id}`] ? 'Sync in corso...' : 'Forza Sync Prodotti'}
                  </button>
                </div>
              </div>
              
              <div className="modal-footer">
                <button 
                  className="btn btn-secondary"
                  onClick={() => setShowPermissionsModal(false)}
                >
                  Chiudi
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal Modifica Merchant Account */}
        {showEditModal && merchantDetails && (
          <div className="modal-overlay">
            <div className="modal">
              <div className="modal-header">
                <h3>Modifica Merchant Account</h3>
                <button 
                  className="modal-close"
                  onClick={() => setShowEditModal(false)}
                >
                  &times;
                </button>
              </div>
              
              <div className="modal-body">
                <h4>Merchant Account: {merchantDetails.name}</h4>
                <p>ID: {merchantDetails.id}</p>
                
                <div className="edit-form">
                  <div className="form-group">
                    <label>Nome Merchant:</label>
                    <input
                      type="text"
                      value={editMerchantForm.name}
                      onChange={(e) => setEditMerchantForm(prev => ({ ...prev, name: e.target.value }))}
                      placeholder="Nome merchant"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Website URL:</label>
                    <input
                      type="url"
                      value={editMerchantForm.websiteUrl}
                      onChange={(e) => setEditMerchantForm(prev => ({ ...prev, websiteUrl: e.target.value }))}
                      placeholder="https://..."
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Telefono:</label>
                    <input
                      type="tel"
                      value={editMerchantForm.businessInformation.phoneNumber}
                      onChange={(e) => setEditMerchantForm(prev => ({ 
                        ...prev, 
                        businessInformation: { 
                          ...prev.businessInformation, 
                          phoneNumber: e.target.value 
                        } 
                      }))}
                      placeholder="+39 123 456 7890"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Indirizzo (via):</label>
                    <input 
                      type="text" 
                      value={editMerchantForm.businessInformation.address.streetAddress} 
                      onChange={(e) => setEditMerchantForm(prev => ({ 
                        ...prev, 
                        businessInformation: { 
                          ...prev.businessInformation, 
                          address: { 
                            ...prev.businessInformation.address, 
                            streetAddress: e.target.value 
                          } 
                        } 
                      }))} 
                      placeholder="Via Roma 123" 
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Città:</label>
                    <input 
                      type="text" 
                      value={editMerchantForm.businessInformation.address.locality} 
                      onChange={(e) => setEditMerchantForm(prev => ({ 
                        ...prev, 
                        businessInformation: { 
                          ...prev.businessInformation, 
                          address: { 
                            ...prev.businessInformation.address, 
                            locality: e.target.value 
                          } 
                        } 
                      }))} 
                      placeholder="Città" 
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Provincia:</label>
                    <input 
                      type="text" 
                      value={editMerchantForm.businessInformation.address.region} 
                      onChange={(e) => setEditMerchantForm(prev => ({ 
                        ...prev, 
                        businessInformation: { 
                          ...prev.businessInformation, 
                          address: { 
                            ...prev.businessInformation.address, 
                            region: e.target.value 
                          } 
                        } 
                      }))} 
                      placeholder="Provincia" 
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>CAP:</label>
                    <input 
                      type="text" 
                      value={editMerchantForm.businessInformation.address.postalCode} 
                      onChange={(e) => setEditMerchantForm(prev => ({ 
                        ...prev, 
                        businessInformation: { 
                          ...prev.businessInformation, 
                          address: { 
                            ...prev.businessInformation.address, 
                            postalCode: e.target.value 
                          } 
                        } 
                      }))} 
                      placeholder="CAP" 
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Customer Service URL:</label>
                    <input 
                      type="url" 
                      value={editMerchantForm.businessInformation.customerService.url} 
                      onChange={(e) => setEditMerchantForm(prev => ({ 
                        ...prev, 
                        businessInformation: { 
                          ...prev.businessInformation, 
                          customerService: { 
                            ...prev.businessInformation.customerService, 
                            url: e.target.value 
                          } 
                        } 
                      }))} 
                      placeholder="https://..." 
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Customer Service Email:</label>
                    <input 
                      type="email" 
                      value={editMerchantForm.businessInformation.customerService.email} 
                      onChange={(e) => setEditMerchantForm(prev => ({ 
                        ...prev, 
                        businessInformation: { 
                          ...prev.businessInformation, 
                          customerService: { 
                            ...prev.businessInformation.customerService, 
                            email: e.target.value 
                          } 
                        } 
                      }))} 
                      placeholder="email@esempio.com" 
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Customer Service Telefono:</label>
                    <input 
                      type="text" 
                      value={editMerchantForm.businessInformation.customerService.phoneNumber} 
                      onChange={(e) => setEditMerchantForm(prev => ({ 
                        ...prev, 
                        businessInformation: { 
                          ...prev.businessInformation, 
                          customerService: { 
                            ...prev.businessInformation.customerService, 
                            phoneNumber: e.target.value 
                          } 
                        } 
                      }))} 
                      placeholder="+39 ..." 
                    />
                  </div>
                </div>
              </div>
              
              <div className="modal-footer">
                <button 
                  className="btn btn-secondary"
                  onClick={() => setShowEditModal(false)}
                >
                  Annulla
                </button>
                <button 
                  className="btn btn-primary"
                  onClick={handleUpdateMerchant}
                  disabled={processing.update || !editMerchantForm.name || !editMerchantForm.websiteUrl}
                >
                  {processing.update ? 'Aggiornamento...' : 'Aggiorna Merchant'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal Azioni Merchant */}
        {showActionsModal && selectedSeller && (
          <div className="modal-overlay">
            <div className="modal">
              <div className="modal-header">
                <h3>Azioni Merchant</h3>
                <button 
                  className="modal-close"
                  onClick={() => setShowActionsModal(false)}
                >
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <div className="merchant-actions-modal-header">
                  {selectedSeller.logo_square ? (
                    <img src={selectedSeller.logo_square} alt="Logo" className="logo-square-large" />
                  ) : (
                    <div className="logo-square-placeholder-large">
                      {selectedSeller.store_name ? selectedSeller.store_name.slice(0,2).toUpperCase() : '??'}
                    </div>
                  )}
                  <div>
                    <div className="seller-name">{selectedSeller.store_name || `${selectedSeller.name} ${selectedSeller.last_name}`}</div>
                    {selectedSeller.seller_handle && <div className="seller-handle">@{selectedSeller.seller_handle}</div>}
                    <div className="merchant-id">ID: {selectedSeller.merchant_id || '-'}</div>
                  </div>
                </div>
                
                {/* Dettagli ultimo aggiornamento */}
                {selectedSeller.merchant_id && (
                  <div className="sync-details">
                    <h5>Dettagli Ultimo Aggiornamento</h5>
                    <div className="sync-info">
                      <p><strong>Stato:</strong> 
                        <span style={{ 
                          marginLeft: '8px',
                          padding: '2px 6px',
                          borderRadius: '3px',
                          backgroundColor: 
                            selectedSeller.sync_status === 'completed' ? '#28a745' :
                            selectedSeller.sync_status === 'in_progress' ? '#ffc107' :
                            selectedSeller.sync_status === 'error' ? '#dc3545' : '#6c757d',
                          color: 'white'
                        }}>
                          {selectedSeller.sync_status === 'completed' ? 'Completato' :
                           selectedSeller.sync_status === 'in_progress' ? 'In Corso' :
                           selectedSeller.sync_status === 'error' ? 'Errore' : 'Idle'}
                        </span>
                      </p>
                      {selectedSeller.last_sync && (
                        <p><strong>Ultimo Sync:</strong> {formatDate(selectedSeller.last_sync)}</p>
                      )}
                      {selectedSeller.sync_started_at && (
                        <p><strong>Iniziato:</strong> {formatDate(selectedSeller.sync_started_at)}</p>
                      )}
                      {selectedSeller.sync_ended_at && (
                        <p><strong>Completato:</strong> {formatDate(selectedSeller.sync_ended_at)}</p>
                      )}
                      {selectedSeller.sync_error && (
                        <p><strong>Errore:</strong> <span style={{color: '#dc3545'}}>{selectedSeller.sync_error}</span></p>
                      )}
                    </div>
                  </div>
                )}
                
                {/* Statistiche prodotti */}
                <div className="product-stats">
                  <h5>Statistiche Prodotti</h5>
                  <div className="stats-grid">
                    <div className="stat-item">
                      <span className="stat-label">Varianti Elasticsearch:</span>
                      <span className="stat-value">{selectedSeller.variants_count?.toLocaleString() || 0}</span>
                    </div>
                    <div className="stat-item">
                      <span className="stat-label">Tariffe Spedizione:</span>
                      <span className="stat-value">{selectedSeller.shipping_rates_count || 0}</span>
                    </div>
                  </div>
                </div>
                <div className="actions-list">
                  {selectedSeller.is_loverlist ? (
                    <>
                      <button
                        className="btn btn-success btn-sm"
                        onClick={() => { 
                          // Per Loverlist, usa l'endpoint CSS specifico
                          handleUploadProducts(CSS_DOMAIN_ID, null); 
                          setShowActionsModal(false); 
                        }}
                        disabled={processing[`upload_${CSS_DOMAIN_ID}`]}
                        style={{ backgroundColor: '#007bff', borderColor: '#007bff' }}
                      >
                        {processing[`upload_${CSS_DOMAIN_ID}`] ? 'Sync CSS Loverlist in corso...' : 'Forza Sync CSS Loverlist'}
                      </button>
                      <div className="loverlist-info">
                        <p><strong>Info:</strong> Questo account sincronizza tutti i prodotti di tutti i seller su Google Shopping.</p>
                        <p><strong>Intervallo:</strong> Ogni 24 ore</p>
                      </div>
                    </>
                  ) : selectedSeller.merchant_id ? (
                    <>
                      <button
                        className="btn btn-success btn-sm"
                        onClick={() => { handleUploadProducts(selectedSeller.merchant_id, selectedSeller.user_id); setShowActionsModal(false); }}
                        disabled={processing[`upload_${selectedSeller.merchant_id}`]}
                      >
                        {processing[`upload_${selectedSeller.merchant_id}`] ? 'Sync in corso...' : 'Forza Sync Prodotti'}
                      </button>
                      <button
                        className="btn btn-warning btn-sm"
                        onClick={() => { handleEditMerchant(selectedSeller.merchant_id); setShowActionsModal(false); }}
                      >
                        Modifica Merchant
                      </button>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => { handleDeleteMerchant(selectedSeller.merchant_id); setShowActionsModal(false); }}
                      >
                        Elimina Merchant
                      </button>
                    </>
                  ) : (
                    <div className="no-merchant-actions">
                      <p>Nessun merchant account creato per questo seller.</p>
                      <button
                        className="btn btn-success btn-sm"
                        onClick={() => { 
                          handleCreateMerchant(selectedSeller.user_id); 
                          setShowActionsModal(false); 
                        }}
                        disabled={processing[selectedSeller.user_id]}
                      >
                        {processing[selectedSeller.user_id] ? 'Creazione...' : 'Crea Merchant Account'}
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button 
                  className="btn btn-secondary"
                  onClick={() => setShowActionsModal(false)}
                >
                  Chiudi
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default AdminMerchantAccountsPage; 